/** One per slide: the key, and what picks its illustration (IntroIllustrations.tsx) and colours
 *  (the --intro-<id>-* tokens, via styles.css `[data-tone]`). */
export type IntroSlideId = 'team' | 'payroll' | 'copilot';

export interface IntroSlide {
  id: IntroSlideId;
  title: string;
  /** Three short lines, each one thing the product does. */
  points: readonly string[];
}

/**
 * The phone app's first-run benefit slides: three, each packing several features, because a new
 * owner swipes past a long tour (the team, the money, then the copilot). Every claim is something
 * the product does today (see CLAUDE.md) — this is the first thing a prospective customer reads, so
 * it says nothing the product doesn't back up. No face matching: the punch selfie is kept for review,
 * so the attendance line claims the location check only. Kept short enough to read at a glance on a
 * 360dp screen without scrolling.
 */
export const INTRO_SLIDES: readonly IntroSlide[] = [
  {
    id: 'team',
    title: 'Your whole team, from your phone',
    points: [
      'Add people from your contacts. They join by SMS.',
      'Selfie and location punch-in, no paper registers.',
      'Leave, approvals and chat in one app.',
    ],
  },
  {
    id: 'payroll',
    title: 'Payroll done right, India and beyond',
    points: [
      'PF, ESI, TDS and PT worked out for you.',
      'Payslips, Form 16 and filings, ready on time.',
      'Expense claims approved on the go.',
    ],
  },
  {
    id: 'copilot',
    title: 'An HR assistant that asks first',
    points: [
      'Ask about leave, pay or policies, by voice or text.',
      'It drafts the change. Nothing happens until you approve.',
      'Aadhaar, PAN and bank details stay encrypted.',
    ],
  },
];
